import { isMultirole } from '@/authProvider'
import Storage from '../../lib/Storage'

type CanAccessParams = {
  action: string
  resource: string
  record?: unknown
}

const canAccess = ({ resource }: CanAccessParams) => {
  const { getActiveRole } = Storage()
  const type = getActiveRole()?.type

  const result: { [key: string]: boolean } = {
    'review-queue': ['VENDOR'].includes(type),
    calendar: ['PUBLISHER', 'AFFILIATE'].includes(type),
    resources: ['PUBLISHER', 'AFFILIATE'].includes(type),
    '/earnings/deductions': ['PUBLISHER', 'VENDOR'].includes(type),
    roles: isMultirole()
  }

  return Promise.resolve(result[resource] ?? true)
}

export default canAccess
